"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Text = _interopRequireDefault(require("react-native-web/dist/exports/Text"));

var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/exports/StyleSheet"));

var _Animated = _interopRequireDefault(require("react-native-web/dist/exports/Animated"));

var _Easing = _interopRequireDefault(require("react-native-web/dist/exports/Easing"));

var _TouchableWithoutFeedback = _interopRequireDefault(require("react-native-web/dist/exports/TouchableWithoutFeedback"));

var _quarkCore = require("quark-core");

var _styles = require("quark-core/styles");

var _styles2 = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseButton, _React$Component);

  function BaseButton() {
    var _ref;

    var _this;

    _classCallCheck(this, BaseButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = BaseButton.__proto__ || Object.getPrototypeOf(BaseButton)).call.apply(_ref, [this].concat(args))); // initial state

    _initialiseProps.call(_this);

    _this.state = {
      opacity: new _Animated.default.Value(0),
      animation: null
    };
    return _this;
  }

  _createClass(BaseButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          style = _props.style,
          children = _props.children,
          size = _props.size,
          activeColor = _props.activeColor,
          constrainSize = _props.constrainSize,
          defaultColor = _props.defaultColor,
          onPress = _props.onPress,
          disabled = _props.disabled,
          disabledColor = _props.disabledColor,
          textColor = _props.textColor,
          unused = _objectWithoutProperties(_props, ["style", "children", "size", "activeColor", "constrainSize", "defaultColor", "onPress", "disabled", "disabledColor", "textColor"]); // pull out the used state


      var loading = this.state.loading;
      return React.createElement(_TouchableWithoutFeedback.default, {
        onPressIn: disabled || loading ? null : this._pressIn,
        onPressOut: disabled || loading ? null : this._pressOut,
        onPress: disabled || loading ? null : this._press,
        accessible: !disabled
      }, React.createElement(_Animated.default.View, _extends({}, unused, {
        style: [_styles2.styles.container, _styles2.containerSizes[size], constrainSize && _styles2.sizeConstraints[size], disabled && _styles2.styles.disabled, {
          backgroundColor: disabled ? disabledColor : this.state.opacity.interpolate({
            inputRange: [0, 1],
            outputRange: [defaultColor, activeColor || defaultColor]
          })
        }, style]
      }), this.state.loading ? React.createElement(_quarkCore.LoaderBubbles, {
        color: textColor,
        radius: 5
      }) : children));
    }
  }]);

  return BaseButton;
}(React.Component);

BaseButton.defaultProps = {
  size: 'medium',
  constrainSize: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._pressIn = function () {
    // if there is a press handler to deal with
    if (_this2.props.onPressIn) {
      var _this2$props;

      // call it
      (_this2$props = _this2.props).onPressIn.apply(_this2$props, arguments);
    }

    _this2.setState({
      animation: _Animated.default.timing(_this2.state.opacity, {
        toValue: 1,
        duration: 100
      })
    }, function () {
      return _this2.state.animation && _this2.state.animation.start();
    });
  };

  this._pressOut = function () {
    // stop the keypress animation if its running
    // if there is a press handler to deal with
    if (_this2.props.onPressOut) {
      var _this2$props2;

      // call it
      (_this2$props2 = _this2.props).onPressOut.apply(_this2$props2, arguments);
    } // start the animation to return to normal state


    _Animated.default.timing(_this2.state.opacity, {
      toValue: 0,
      duration: 150
    }).start();
  };

  this._press = function () {
    // if there is a press handler to deal with
    if (_this2.props.onPress) {
      var _this2$props3;

      // call it
      var pressPromise = (_this2$props3 = _this2.props).onPress.apply(_this2$props3, arguments); // if the press callback returned a promise


      if (pressPromise && pressPromise.then && pressPromise.catch) {
        // set the loading state to true
        _this2.setState({
          loading: true
        }); // when the promise is resolved, set the loading state to false


        pressPromise.then(function () {
          return _this2.setState({
            loading: false
          });
        }); // if the promise rejected we should also hide the loading indicator

        pressPromise.catch(function () {
          return _this2.setState({
            loading: false
          });
        });
      }
    }
  };
};

var _default = BaseButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/buttons/Base/index.js
// module id = ./node_modules/quark-core/components/buttons/Base/index.js
// module chunks = 0